import React, { useState } from "react";
import { toast } from "react-toastify";
import AppsModal from "./AppsModal";
import InstructionAppModal from "./InstructionAppModal";
import QRCodeModal from "./QRCodeModal";
import SuccessModal from "./SuccessModal";

interface Props {
  userInfo: {
    email: string;
    password: string;
  };
  setOpenConfigModals: (open: boolean) => void;
  onMfaSetupComplete?: () => void;
}

const MfaConfig: React.FC<Props> = ({ userInfo, setOpenConfigModals, onMfaSetupComplete }) => {
  const [appModal, setAppModal] = useState(true);
  const [instructionAppModal, setInstructionAppModal] = useState(false);
  const [qrModal, setQRModal] = useState(false);
  const [successModal, setSuccessModal] = useState(false);
  const [backupCode, setBackupCode] = useState("");

  const handleInstructionAppModal = () => {
    setInstructionAppModal(true);
    setAppModal(false);
  };

  const handleQRModal = () => {
    setQRModal(true);
    setInstructionAppModal(false);
  };

  const handleSuccessModal = () => {
    setSuccessModal(true);
    setQRModal(false);
  };

  const handleSuccessToggle = () => {
    setSuccessModal(false);
    setBackupCode("");
    setOpenConfigModals(false);
    toast.success("Autenticación de dos factores configurada correctamente");
    
    // Trigger auto-login if callback provided
    if (onMfaSetupComplete) {
      onMfaSetupComplete();
    }
  };

  const handleClose = () => {
    setAppModal(false);
    setInstructionAppModal(false);
    setQRModal(false);
    setSuccessModal(false);
    setBackupCode("");
    setOpenConfigModals(false);
  };

  const handleAppModalClose = () => {
    setAppModal(false);
    setOpenConfigModals(false);
  };

  const handleInstructionModalClose = () => {
    setInstructionAppModal(false);
    setOpenConfigModals(false);
  };

  const handleQRModalClose = () => {
    setQRModal(false);
    setOpenConfigModals(false);
  };

  return (
    <>
      <AppsModal
        isOpen={appModal}
        handleNextModal={handleInstructionAppModal}
        toggle={handleAppModalClose}
      />
      <InstructionAppModal
        isOpen={instructionAppModal}
        handleNextModal={handleQRModal}
        toggle={handleInstructionModalClose}
      />
      <QRCodeModal
        userName={userInfo?.email || ""}
        password={userInfo?.password || ""}
        isOpen={qrModal}
        handleNextModal={handleSuccessModal}
        toggle={handleQRModalClose}
        setBackupCode={setBackupCode}
      />
      <SuccessModal
        isOpen={successModal}
        toggle={handleSuccessToggle}
        backupCode={backupCode}
      />
    </>
  );
};

export default MfaConfig;
